//#region import
import React, { Fragment, createContext, useContext, useEffect, useRef, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Grid, Typography } from '@mui/material';
import { BtnCancel, BtnDraft, BtnEdit, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import FroalaEditor from 'react-froala-wysiwyg';
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
import 'froala-editor/js/languages/th';
import AccordionPanel from '../components/AccordionPanel';
import { useLocation } from 'react-router';
import ContentWrapper from '../components/ContentWrapper';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
//#endregion

const Panel3 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [sRelationPolicy, setsRelationPolicy] = useState(null);    

    const ref_sRelationPolicy = useRef<any>(null);

    const configs = (placeholderText) => {
        let ObjConfigs = {
            key: "0BA3jA11B5C7C4A4D3aIVLEABVAYFKc2Cb1MYGH1g1NYVMiG5G4E3C3A1C8A6D4A3B4==",
            attribution: false,
            heightMin: 200,
            heightMax: 2000,
            imageUploadURL: process.env.REACT_APP_API_URL + "api/UploadFile/UploadFileFroala",
            // quickInsertButtons: ['image', 'table', 'ol', 'ul', 'myButton'],
            // pluginsEnabled: ['quickInsert', 'image', 'table', 'lists'],
            placeholderText: placeholderText,
            language: 'th',
            toolbarButtons: {
                moreText: {
                    buttons: ['bold', 'italic', 'underline', 'subscript', 'superscript', 'fontSize', 'textColor', 'clearFormatting']
                },
                moreParagraph: {
                    buttons: ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify'],
                    buttonsVisible: 4
                },
                moreRich: {
                    buttons: ['insertTable', 'insertImage', 'insertHR']
                },
                moreMisc: {
                    buttons: ['undo', 'redo', 'fullscreen'],
                    align: 'right',
                    buttonsVisible: 3
                }
            },
            quickInsertButtons: ['table', 'image', 'hr'],
            pasteAllowedStyleProps : ['color'], //'font-size', 
            imageEditButtons: ['imageReplace', 'imageAlign', 'imageCaption', 'imageRemove'],
            charCounterCount: false,
        }
        return ObjConfigs;
    };

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel3, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);
            setsRelationPolicy(result.objResult.sRelationPolicy);

            if (ref_sRelationPolicy.current) ref_sRelationPolicy.current.props.onModelChange(result.objResult.sRelationPolicy ?? "");
        });
    };

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        if (nModeID === EnumSaveModeProject.Submit && (sRelationPolicy === null || sRelationPolicy === "")) {
            return DialogFn.Warning("กรุณากรอกข้อมูลให้ครบถ้วน");
        } 
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel3,
            isFastTrack: isFastTrack,

            sRelationPolicy : sRelationPolicy,

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel3, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 3, isEdit: false});
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <AccordionPanel
            header={"3. ความสอดคล้องและความสัมพันธ์กับยุทธศาสตร์/นโยบาย/แผนที่เกี่ยวข้อง"} 
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >
            <Grid id={"myDivPanel3"} item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                {/* Subject 1 */}
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12}>
                        {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
                            <FroalaEditor
                                model={sRelationPolicy}
                                onModelChange={setsRelationPolicy}
                                // tag='textarea'
                                config={configs("ระบุความสอดคล้องและความเชื่อมโยงระหว่างโครงการที่เสนอ กับ ยุทธศาสตร์นโยบาย แผน และ/หรือระเบียบที่เกี่ยวข้อง (อาจมีความสอดคล้อง/เชื่อมโยงมากกว่าหนึ่งอย่าง) ดังนี้ <br/> ๓.๑ ยุทธศาสตร์ชาติ ๒๐ ปี <br/> ๓.๒ นโยบาย/แผนต่าง ๆ ที่เกี่ยวข้อง เช่น แผนพัฒนาเศรษฐกิจและสังคมแห่งชาติและ/หรือแผนการปฏิบัติงานหน่วยงาน เป็นต้น <br/> ทั้งนี้ ต้องมีการเชื่อมโยงถึงยุทธศาสตร์ / นโยบาย / แผนของกรมทรัพยากรธรณีและภาคีหน่วยงานที่เกี่ยวข้องด้านแหล่งซากดึกดําบรรพ์และซากดึกดําบรรพ์เช่น นโยบายการคุ้มครองแหล่งซากดึกดําบรรพ์และซากดึกดําบรรพ์ ระยะ ๕ ปี (พ.ศ. ๒๕๖๖ – ๒๕๗๐) หรือแผนแม่บทการคุ้มครองแหล่งซากดึกดําบรรพ์และซากดึกดําบรรพ์ พ.ศ. ๒๕๖๖ – ๒๕๘๐")}
                                ref={ref_sRelationPolicy}
                            />
                            :
                            <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '1px', borderRadius: '10px', }}>
                                <FroalaEditorView
                                    // tag='div'
                                    model={sRelationPolicy} 
                                />
                            </ContentWrapper> 
                        }
                    </Grid>
                </Grid>                     
            </Grid>
            {nProjectID === 0 || nStatusID === EnumProjectStatusID.nStatusID_11 ?
                <></>
                :
                (isPermission === true &&
                    (isModeSecretary !== true ?
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                            {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                <Grid item>
                                    <BtnDraft id={"btnDraft_Panel3"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                </Grid>
                            }
                            <Grid item>
                                <BtnSendRequest id={"btnSend_Panel3"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => {handleSubmit(EnumSaveModeProject.Submit) }} />
                            </Grid> 
                        </Grid>
                    : 
                        (isModeSecretary === true ?
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                {isEditSecretary === false ?
                                    <Grid item>
                                        <BtnEdit id={"btnEdit_Panel3"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel3").scrollIntoView({ behavior: "smooth" });}} />
                                    </Grid>
                                    :
                                    <>
                                        <Grid item>
                                            <BtnCancel id={"btnCancel_Panel3"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                        </Grid>
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel3"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                        </Grid>
                                    </>
                                }   
                            </Grid>
                            : <></>
                        )
                    )
                )
            }
        </AccordionPanel>
    )
}
export default Panel3;
